export async function readErrorMessage(response: Response) {
  const body = (await response.json().catch(() => null)) as { detail?: string } | null;
  return body?.detail ?? "요청을 처리하지 못했습니다.";
}
